<div [class]="wrapperClass + ' text-start'">
  @if (label && label.length) {
    <label [for]="id + '_input'">
      {{ label }}
      @if ((controlIsRequired$ | async) && showRequiredStar) {
        <em class="text-danger">*</em>
      }
    </label>
  }
  <textarea [class]="inputClass"
            [formControl]="control"
            [id]="id + '_input'"
            [placeholder]="placeholder"
            [readonly]="readonly"
            [rows]="rows">
  </textarea>
  <input-error-output [control]="control"></input-error-output>
</div>
